import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { OrgProvider } from "./OrgContext";
import "./i18n"; // Import i18n configuration

// Suppress benign ResizeObserver loop error (e.g. from Recharts in responsive layouts).
// Only window.onerror + return true suppresses console logging; addEventListener return/stopPropagation does not.
const prevOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (message && typeof message === "string" && message.includes("ResizeObserver loop")) {
    return true;
  }
  if (typeof prevOnError === "function") {
    return prevOnError.call(this, message, source, lineno, colno, error);
  }
  return false;
};

if (process.env.REACT_APP_ENVIRONMENT === "Trial") {
  console.log = console.warn = console.error = () => {};
}

const app = (
  <Provider store={store}>
    <OrgProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </OrgProvider>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
